<template>
  <div class="inventory-ring">
    <ve-ring
      width="130px"
      height="130px"
      :tooltip-visible="false"
      :legend-visible="false"
      :settings="settings"
      :extend="extend"
      :colors="[color, '#EEEEEE']"
      :data="data"
    ></ve-ring>
    <div class="ring-msg">
      <div class="msg-cell">{{ type }}</div>
      <div class="num msg-cell">{{ number }}</div>
      <div class="msg-cell">{{ currencySymbol }}{{ amount }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 显示名
    type: {
        type: String,
        default: "已下单"
    },
    // 数量
    number: {
        // type: Number,
        default: 0
    },
    // 金额
    amount: {
        // type: Number,
        default: 0
    },
    // 币种符号
    currencySymbol: {
        type: String,
        default: "$"
    },
    // 比例
    proportion: {
        // type: Number,
        default: 0
    },
    // 颜色
    color: {
        type: String,
        default: "#1F6EEF"
    },
    total: {
      //  type: Number,
        default: 0 
    }
  },
  watch: {
    proportion(val) {
      // 中间比例
      this.extend.graphic[0].style.text = Math.floor(Number(val) * 100) + " %"
    },
    number(val) {
      this.data.rows[0].value = val
    },
    total(val) {
      this.data.rows[1].value = val - this.number
    }
  },
  data() {
    return {
        data: {
          columns: ["name", "value"],
          rows: [
            { value: 0 },
            { value: 0 }
          ],
        },
        extend: {
          series: {
            center: ["50%", "50%"],
            silent: true
          },
          graphic: [
            {
              type: "text",
              left: "center",
              top: "44%",
              style: {
                text: "0%",
                textAlign: "center",
                fill: "#666",
                fontSize: 18,
              },
            },
          ],
        },
        settings: {
          radius: ["80%", "60%"], // 环图外半径与内半径
          hoverAnimation: false, // 关闭 hover 在扇区上的放大动画效果
          label: {
            //去除饼图的指示折线label
            normal: {
              show: false,
              position: "inside",
            },
          },
          labelLine: {
            show: false, // 不显示视觉引导线
          },
        },
    };
  },
  methods: {
    // 数据处理
    dataHandle() {
        // 画图
        this.data.rows[0].value = this.number
        this.data.rows[1].value = this.total - this.number
    },
  },
  created() {
  }
};
</script>

<style scoped lang="scss">
.inventory-ring {
    display: flex;
    align-items: center;
}
.ring-msg {
  padding-top: 22px;
  padding-left: 22px;
  font-size: 13px;
  color: #333;
  display: flex;
  font-weight: 600;
  flex-direction: column;
  .msg-cell {
    padding-bottom: 11px;
    &.num {
      font-size: 23px;
      font-weight: normal;
    }
  }
}
</style>